import { Chain } from 'wagmi';
import { getChain } from './chains';

const getVaultIcon = (
  vaultId: string,
  chainId: Chain['id'],
  legacy?: boolean
) => {
  const id = vaultId?.replace(/ /g, '-')?.toLocaleLowerCase() || '';
  const chain = getChain(chainId);

  /*
   * V2 ETH = https://assets.nftx.io/vaults-v2/20/256x256.png
   * V2 other chain = https://assets.nftx.io/vaults-v2/[CHAIN]/20/256x256.png
   * V3 = https://assets.nftx.io/vaults-v3/[CHAIN]/20/256x256.png
   */
  const chainPath =
    legacy && chain.id === 1
      ? ''
      : chain.id === 1
      ? '/eth'
      : `/${chain.network.toLowerCase()}`;

  return `https://images.nftx.io/cdn-cgi/image/anim=false,width=150,height=150,format=auto/https://assets.nftx.io/vaults-${
    legacy ? 'v2' : `v3`
  }${chainPath}/${id}/256x256.png`;
};

export default getVaultIcon;
